import React, { Component, useState, useEffect } from 'react';
import { Button, Row, Col, Pagination } from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import $, { data } from 'jquery'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import PocketbookStudentSumary from "../../components/PocketbookStudentSumary";
import { Helmet } from "react-helmet";
import HeaderText from '../../components/HeaderText'
import html2canvas from 'html2canvas';
import { Doughnut } from "react-chartjs-2";
import { useParams } from 'react-router-dom';
import { Chart, ArcElement } from 'chart.js'
Chart.register(ArcElement);

const PocketbookStudentDetail = props => {
    const [strengths, setStrengths] = useState([]);
    const [allPercent, setSetPercent] = useState([]);
    const [key, setSetKey] = useState([]);
    const [selfText, setSelfText] = useState([]);
    const [graphData, setGraphData] = useState(null);
    const [maxValue, setMaxValue] = useState(0);
    const [roomIdCurrent, setRoomId] = useState('');
    const [studentName, setStudentName] = useState('');
    const [studentIdTemp, setStudentId] = useState('');
    const [totalActivity, setTotalActivity] = useState(0);
    const [styleEmpty, setStyleEmpty] = useState('d-none');
    const [styleData, setStyleData] = useState('');




    let newStrengths = [];
    let color = {

        "brave": "#FFCECE",
        "honesty": "#FF9B9B",
        "perseverance": "#E04E4E",
        "zest": "#B41616",
        "fairness": "#A1AEF9",
        "citizenship": "#465BCC",
        "leadership": "#1A2979",
        "humility": "#FFD2F5",
        "forgiveness": '#FFA1E9',
        "self_regulation": "#D761BB",
        "prudence": "#801967",
        "hope": "#FFDEC8",
        "spirituality": "#FFC096",
        "beauty_excellence": "#EA833D",
        "humor": "#E46C1A",
        "gratitude": '#923806',
        "creativity": "#CDFFF6",
        "curiosity": '#8FFFEA',
        "judgement": "#67D2BE",
        "love_of_learning": "#2FA992",
        'perspective': '#147B68',
        "kindness": "#D8F4FF",
        "social": "#96DAF5",
        "love": "#2893BD",
    };

    // let value = [];
    const { roomId, studentId } = useParams();
    let labelsValue = [], backgroundColorValue = [], dataValue = [];
    let tempMax = 0;
    useEffect(() => {

        try {
            var user = AuthService.getCurrentUser();
            //todo ปีการศึกษา        
            var filter;

            UserService.getRoomDetail(roomId).then((response) => {
                filter = {
                    "domain": user.domain.name,
                    "roomId": roomId,
                    "year": response.data.data.year,
                    "term": response.data.data.term,
                };
            }).then(() => {

                // UserService.activitiesTotal(filter).then((response) => {   

                //     var total = 0;
                //     if (response && response.data && response.data.data[0]) {
                //     total = response.data.data[0].total;
                //     }      

                //     return total;
                // }).then((total) => {   setTotalActivity(total)    });  

                UserService.getActivities({
                    limit: 50,
                    domain: filter.domain,
                    studentId: studentId,
                    year: filter.year,
                    term: filter.term
                }).then((res) => {
                    const totalActivity = res.data?.data
                    setTotalActivity(totalActivity.length)
                })

                UserService.getStrengths().then((response) => {

                    for (const [index, str] of response.data.data.entries()) {
                        newStrengths[str.id] = {
                            image: str.imageUrl,
                            name: str.name,
                            description: str.description
                        }
                    }
                    setStrengths(newStrengths)
                    return newStrengths
                }).then((apiStrengths) => {
                    // console.log(apiStrengths);
                    UserService.getFriendShipList(studentId, filter).then((res) => {
                        var allAnswer0 = [];
                        var sum = 0;
                        var maxPercent = 0;
                        var percent = [];
                        var key = [];
                        var RID = res.data.data[0].room.id;


                        if (res.data.data[0] != undefined) {
                            setStudentName(res.data.data[0].user.fullName);
                            setStudentId(res.data.data[0].user.id);
                            for (const [index, aAnswer] of res.data.data[0].others.entries()) {
                                console.log(aAnswer);

                                if (aAnswer.answerAt != null) {
                                    sum += 3;

                                    if (allAnswer0[aAnswer.answers[0].values[0]] === undefined) {
                                        allAnswer0[aAnswer.answers[0].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[0].values[0]]++
                                    }

                                    if (allAnswer0[aAnswer.answers[1].values[0]] === undefined) {
                                        allAnswer0[aAnswer.answers[1].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[1].values[0]]++
                                    }


                                    if (allAnswer0[aAnswer.answers[2].values[0]] === undefined) {
                                        allAnswer0[aAnswer.answers[2].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[2].values[0]]++
                                    }

                                    if (studentId === aAnswer.user.id) {
                                        var selfText = aAnswer.answers[3].values[0];
                                        setSelfText(selfText);
                                    }

                                }

                            }

                            // console.log(allAnswer0);
                            var myArr0 = Object.fromEntries(
                                Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                            );


                            $.each(myArr0, function (index, value) {
                                var numberValue = ((value * 100) / sum).toFixed(2);
                                percent[index] = numberValue + "%";
                                key.push(index);
                                labelsValue.push(newStrengths[index].name);
                                backgroundColorValue.push(color[index]);
                                dataValue.push(numberValue);
                                if (parseFloat(maxPercent) < parseFloat(numberValue)) {
                                    maxPercent = parseFloat(numberValue);
                                }
                            });
                        }
                        var data = { 'percent': percent, 'key': key, 'maxPercent': maxPercent, 'roomIdCurrent': RID };
                        return data;

                    }).then((res) => {

                        setSetPercent(res.percent);
                        setSetKey(res.key);
                        setMaxValue(res.maxPercent)
                        setRoomId(res.roomIdCurrent);
                        tempMax = res.maxPercent;

                    }).then((res) => {
                        var graphData2 = {
                            labels: labelsValue,
                            datasets: [
                                {
                                    label: 'Rainfall',
                                    backgroundColor: backgroundColorValue,
                                    // hoverBackgroundColor: [
                                    // '#501800',
                                    // '#4B5000'
                                    // ],
                                    data: dataValue
                                }
                            ]
                        };
                        setGraphData(graphData2);

                        if (tempMax === 0) {
                            setStyleData('d-none');
                            setStyleEmpty('');
                        } else {
                            setStyleData('');
                            setStyleEmpty('d-none');
                        }
                    });
                });
            });
        } catch (error) {

        }
        // AuthService.setComputeRoomId('60c0e14221965c37a7c1b75f')
    }, [])

    const exportLink = (link) => {
        if (link) {
            window.open(link, '_blank').focus();
        }
    }
    return (
        <div className={`pocketbook`}>
            <Helmet>
                <title>PocketbookStudentDetail - Mindsetmaker.co</title>
                <meta property="og:title" content={`PocketbookStudentDetail- Mindsetmaker.co`} />
                <meta property="og:description" content={`PocketbookStudentDetail`} />
            </Helmet>
            <Row>
                <Col className="header-text">
                    <div className="text-center py-2">
                        <h1 className="m-0">สมุดพกจิตวิทยาเชิงบวก</h1>
                        <h3 className="font-sarabun font-weight-600">{studentName}</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} style={{ "fontSize": '14px' }} className="text-left pb-2 main-detail px-3 pt-3">
                    <a href={`/pocketbook/${roomIdCurrent}`} className="click-pointer"><span style={{ "color": '#B6C2D5' }} className="click-pointer font-sarabun">สมุดพก &#62;</span></a><span style={{ "color": '#848DA3' }} className="font-sarabun-bold"> {studentName}</span>
                </Col>
            </Row>
            <Row className="main-detail m-auto text-center">
                <Col xs={12} md={6}>
                    <img src="/images/pocketbook/cover.png" width="350" className="m-auto" style={{ "maxWidth": "100%" }} />
                </Col>
                <Col xs={12} md={6} className="g-detail m-auto">
                    <Row>
                        <Col xs={12} className="main-detail text-center px-0 pt-3">
                            <h2 className="font-sarabun-bold">ช่วงเวลาที่นักเรียนได้เรียนรู้<span className="doNotWrap">เรื่องราวเชิงบวก</span></h2>
                        </Col>
                    </Row>
                    <Row className="px-3">
                        <Col xs={12} className="result-graph px-1 d-flex py-3 border-radius-12 blog-resutl blog-resutl m-auto">
                            <div className="text-center d-inline d-inline" style={{ "width": '50%', "borderRight": "1px solid #B6C2D5" }}>
                                <div className="text-left m-auto d-flex" style={{ "width": "fit-content" }}>
                                    <div className="px-1 d-inline"><img src='/images/pocketbook/book.png' height="40" className="m-auto" /></div>
                                    <div className="px-1 d-inline t-12 font-sarabun" >จำนวนครั้งกิจกรรม <br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivity || '-'} รอบ</h3></div>
                                </div>
                            </div>

                            <div className="text-center d-inline d-inline" style={{ "width": '50%' }}>
                                <div className="text-left m-auto d-flex" style={{ "width": "fit-content" }}>
                                    <div className="px-1 d-inline"><img src='/images/pocketbook/stopwatch2.png' width="40" className="m-auto" /></div>
                                    <div className="px-1 d-inline t-12 font-sarabun">คิดเป็นช่วงเวลาเชิงบวก <br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivity * 20} นาที</h3></div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="px-3">
                        <Col xs={12} className="main-detail px-0 py-3">
                            <a href={`/report/overview/${roomIdCurrent}?studentId=${studentIdTemp}`} ><div className="w-100 t-b-12 green-text text-center font-sarabun-bold"><u>ดูกิจกรรม Homeroom เพิ่มเติม</u></div></a>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <hr className="main-detail my-5"></hr>
            <Row>
                <Col xs={12} className="main-detail px-3 pb-3">
                    <h2 className="font-sarabun-bold text-center">อุปนิสัยเชิงบวกของเราที่โดดเด่น<span className="doNotWrap">ในเทอมนี้</span></h2>
                </Col>
            </Row>
            <Row className={`${styleEmpty}`}>
                <h3 className="font-sarabun-bold text-center m-auto">ยังไม่มีการประเมิน</h3>
            </Row>
            <Row className={`main-detail m-auto ${styleData}`}>
                <Col xs={12} md={6} className="px-0" >
                    <div id="capture" className="d-flex" style={{ "position": "relative", "left": "0%" }}>
                        <div className="w-100 m-auto" style={{ "maxWidth": "400px", "padding": "0px 20px 0px 20px" }}>
                            {
                                (graphData) ? (
                                    <Doughnut
                                        data={graphData}
                                        options={{
                                            plugins: {
                                                legend: {
                                                    display: false,
                                                    position: 'bottom'
                                                }
                                            },
                                            responsive: true,
                                            maintainAspectRatio: true
                                        }}
                                    />
                                ) : (
                                    <div></div>
                                )
                            }

                        </div>
                        <div style={{ "position": "absolute", "zIndex": "-100" }} className="w-100 text-center graph-percent-text"><h1>{maxValue}%</h1></div>
                    </div>
                </Col>

                <Col xs={12} md={6} className="p-0 pt-3 pb-3 g-detail" style={{ "display": "flex" }} >
                    <Row className="m-auto">
                        {key.map((key, i) => (
                            <Col xs={6} md={4} className="px-3 d-flex" key={key}>
                                <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                <div className="d-grid pl-2"><span className="t-14 font-sarabun">{strengths[key].name} {allPercent[key]}</span></div>
                            </Col>
                        ))}
                    </Row>
                </Col>

            </Row>
            <hr className={`main-detail my-4 ${styleData}`}></hr>
            <Row className={`${styleData}`}>
                <Col xs={12} className="main-detail px-3 pb-3">
                    <h4 className="font-sarabun-bold text-center">เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวก<span className="doNotWrap">ของตัวเอง</span></h4>
                    <div className='border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height'>
                        <div className='font-sarabun'>{selfText}</div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className="main-detail px-0 pb-3">
                    <a href={`/report/friendship/${roomIdCurrent}?studentId=${studentIdTemp}`}> <div className="w-100 t-b-12 green-text text-center font-sarabun-bold"><u>ดูมุมมองอื่นๆ เพิ่มเติม</u></div></a>
                </Col>
                <Col xs={12} className="text-center my-1 mb-5 pb-3">
                    <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5  font-sarabun-bold btn btn-primary export-btn" ><h5 className="mb-0 font-weight-bold" onClick={() => exportLink(`/pocketbook/pdf/${roomId}/${studentId}`)}>Export</h5></Button>
                </Col>
            </Row>
        </div>
    );

}

export default PocketbookStudentDetail;